import ReactDOM from "react-dom/client";
import React, { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.scss";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary/index.tsx";
import Loader from "./components/Loader/index.tsx";
import { Provider } from "react-redux";
import store from "./redux/store.ts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop/ScrollTop.tsx";
import "./instrument.ts";

const initialData = (window as any).__INITIAL_DATA__ || {};

ReactDOM.hydrateRoot(
  document.getElementById("root") as HTMLElement,
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-[100vh]">
            <Loader />
          </div>
        }
      >
        <BrowserRouter>
          <Provider store={store}>
            <ScrollToTop>
              <HelmetProvider>
                <App serverProps={initialData} />
                <ToastContainer style={{ zIndex: 99999999 }} />
              </HelmetProvider>
            </ScrollToTop>
          </Provider>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);
